import cx from 'clsx';
import { RenderCellProps } from 'components/DataGrid';
import { ReactNode } from 'react';
import { GridRow } from '../../types';
import { Segments } from './Segments';
import { segmentsContainer } from './SegmentSpan.css';
import { Selection } from './Selection';
import { Calendar } from './types';
import { useMouseDownHandler } from './useMouseDownHandler';
import { selectionTotState } from './SegmentSpan';
export { useCalendar } from './useCalendar';

export function Edit(props: RenderCellProps<GridRow, any> & { calendar: Calendar }): ReactNode {
  const { calendar } = props;

  const { selection, handleMouseDown, segments } = useMouseDownHandler(props);

  return (
    <div
      // dialogs don't return focus properly
      // tabIndex={tabIndex}
      className={cx(segmentsContainer, selectionTotState(selection))}
      data-testid="position-canvas"
      onMouseDown={handleMouseDown}
      onClick={(event) => {
        // capture cell onClick, we handle selection onMouseDonw
        event.stopPropagation();
      }}
    >
      <Segments segments={segments} selectionState={selection} />
      <Selection selectionState={selection} intervalStart={calendar.interval.start} dayWidth={calendar.dayWidth} />
    </div>
  );
}
